import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-marksentryoutput',
  templateUrl: './marksentryoutput.component.html',
  styleUrls: ['./marksentryoutput.component.css']
})
export class MarksentryoutputComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
